import { render } from "./Zoekresultaten.vue?vue&type=template&id=129bcda7&ts=true"
import script from "./Zoekresultaten.vue?vue&type=script&lang=ts"
export * from "./Zoekresultaten.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__